import { env } from './.env';

export const environment = {
  production: false,
  version: `${env.version}-pre`,
};

export const apiQBonoEnvironment = {
  baseUrl: 'https://api.qaroni.net/ames/v1',
};

export const GoogleMapsEnvironment = {
  key: 'AIzaSyDywlSyhXUpAGC2oOI0TGw8T46XWrkkNCU',
};

export const GoogleReCaptchaEnvironment = {
  sitekey: '6Le0MjUqAAAAAB1iEJ7CGXlPQeXLRjwe_zNofB8b',
};

export const BucketS3Environment = {
  bucket: 'https://cdn1.staging.qaroni.net/ames/2026',
};
